import { useRef } from "react";

export default function useIdGenerator() {
  const idCounter = useRef(0);

  const generateId = (type = "node", existingItems = []) => {
    let newId;
    do {
      idCounter.current += 1;
      newId = `${type}_${idCounter.current}`;
    } while (existingItems.some((item) => item.id === newId));

    return newId;
  };

  return generateId;
}
